<!--Main Table-->
<!--Table-->
<div class="InnerMenu table-main-body">
	<caass-manage-school-container-table [UpdateSchoolCount]="UpdateSchoolCount" (ContainerSelected)="onContainerSelected($event)">
	</caass-manage-school-container-table>
</div>

<!--Lower Table Grid-->
<div class="Grid2Col MarginTop">
	<!--Left Col, Role Table-->
	<div class="InnerMenu">
		<caass-manage-school-container-school-table
			[SelectedContainer]="SelectedContainer"
			(UpdateSchoolCount)="onUpdateSchoolCount($event)"
			(UpdateUserGroups)="onUpdateUserGroups($event)"
		>
		</caass-manage-school-container-school-table>
	</div>

	<!--Right Col, Users Table-->
	<div class="InnerMenu">
		<caass-manage-school-container-user-table [SelectedContainer]="SelectedContainer"> </caass-manage-school-container-user-table>
	</div>
</div>
